import React, { useCallback, useEffect } from 'react'

const InfoModal = ({modal, setModal}) => {

    const {title, text, show } = modal;
    const close = useCallback((e) => {
        setModal({ show: false, title: false, text: false })
    },[setModal])



    useEffect( () => {

        function handleEsc(e){
            e.stopPropagation();
            if (e.key === 'Escape' || e.target.classList.contains('modal_backdrop') )  {
                e.preventDefault();
                close();
            }
        }
        
        document.addEventListener('keydown', handleEsc );
        document.addEventListener('click', handleEsc );

        return function(){
            document.removeEventListener('keydown', handleEsc)
            document.removeEventListener('click', handleEsc)
        }
    },[])

    return (
        <>
            <div className={`modal_backdrop ${show || 'hidden'}`}>
                <div className="modal">
                    <div className="modal_header">
                        <h3>{ title }</h3>
                        <button onClick={ close } title="Stäng"></button>
                    </div>
                    <div className="modal_content">
                        <p>{ text }</p>
                    </div>
                </div>
            </div>
        </>
    )

}

export default InfoModal